import React, { Component } from 'react'
import './TipsOnDesigningTees.css';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';
import maroon from '../../assets/images/tipsImage/maroon.PNG';
import red from '../../assets/images/tipsImage/red.PNG';
import black from '../../assets/images/tipsImage/black.PNG';
import white from '../../assets/images/tipsImage/white.PNG';
import yellow from '../../assets/images/tipsImage/yellow.PNG';
import blue from '../../assets/images/tipsImage/blue.PNG';
import green from '../../assets/images/tipsImage/green.PNG';
import establish from '../../assets/images/tipsImage/establish.PNG';
import layoutsteps from '../../assets/images/tipsImage/layout-steps.PNG';
import wrongWay from '../../assets/images/tipsImage/wrong-way.PNG';
import rightWay from '../../assets/images/tipsImage/right-way.PNG';
import compositionRight from '../../assets/images/tipsImage/composition-right.PNG';
import payImage from '../../assets/images/tipsImage/payImage.PNG';
import complex from '../../assets/images/tipsImage/complex.PNG';
import Capture from '../../assets/images/tipsImage/Capture.JPG';
import mugTips from '../../assets/images/tipsImage/mugTips.JPG';
import mugTips1 from '../../assets/images/tipsImage/mugTips-1.JPG';
import mugTips2 from '../../assets/images/tipsImage/mugTips-2.JPG';
import mugTips3 from '../../assets/images/tipsImage/mugTips-3.JPG';
import mugTips4 from '../../assets/images/tipsImage/mugTips-4.JPG';
import mobileCostomize from '../../assets/images/tipsImage/mobileCostomize.JPG';


class TipsOnDesigningTees extends Component {
    constructor(props){
        super(props);
        this.state={
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    render() {
        return (
            <React.Fragment>
                <LayoutWrapper />
                <main className="main main-container">

                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Tips on Designing Tees</li>
                            </ol>
                        </div>
                        {/* End .container */}
                    </nav>
                    <div className="elementor-widget-container ctnr">
                        <h2 className="elementor-heading-title elementor-size-default mb-1">T-Shirt visuals and a few best</h2>
                        <h2 className="elementor-heading-title elementor-size-default"> combination color ink</h2>
                    </div>
                    <div className="elementor-text-editor elementor-clearfix bdr">
                        <p className="pg">
                            <span className="fnt-tips-color" style={{"fontWeight": "400"}}>
                                T-Shirt visuals and a few best combination color ink to choose to design your own tees shirts
                            </span>
                        </p>
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-2"></div>
                                <div className="col-md-4">
                                    <img src={maroon} alt="tipsImage" className="tips-wdth"/>
                                </div>
                                <div className="col-md-4">
                                    <img src={red} alt="tipsImage" className="tips-wdth"/>
                                </div>
                            </div>
                        </div>
                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color" style={{"fontWeight": "400"}}>
                                    T-Shirt visuals and a few best combination color ink to choose to design your own tees shirts
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-4">
                                        <img src={black} alt="tipsImage" className="tips-wdth"/>
                                    </div>
                                    <div className="col-md-4">
                                        <img src={white} alt="tipsImage" className="tips-wdth"/>
                                    </div>
                                </div>
                            </div>                                               
                        </div>
                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color" style={{"fontWeight": "400"}}>
                                    T-Shirt visuals and a few best combination color ink to choose to design your own tees shirts
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-4">
                                        <img src={yellow} alt="tipsImage" className="tips-wdth"/>
                                    </div>
                                    <div className="col-md-4">
                                        <img src={blue} alt="tipsImage" className="tips-wdth"/>
                                    </div>
                                </div>
                            </div>                                               
                        </div>
                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color" style={{"fontWeight": "400"}}>
                                    T-Shirt visuals and a few best combination color ink to choose to design your own tees shirts
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-4">
                                        <img src={green} alt="tipsImage" className="tips-wdth"/>
                                    </div>                                   
                                </div>
                            </div>                                               
                        </div>
                        <div className="mt-2">
                            <h2 className="elementor-heading-title elementor-size-default mb-1 text-center">STEPS TO DESIGNING TEES</h2>
                        </div>
                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color title-steps font-weight-tips">
                                    1. Establish your goal
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={establish} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                       <p className="step-size">The first step is to ask yourself. </p>
                                       <p className="step-size">Why are you designing a shirt? </p>
                                       <p className="step-size">Establishing the main reason for t-shirt designing is the first step to conceptualizing the design. It would involve branding to an extent, and your shirt must communicate the goal and reason behind your t-shirt designing.  </p>
                                       <p className="step-size">Do you want to showcase your artwork, add a logo, or add a memory that is very close to your heart or just tell a story. </p>
                                    </div>                                   
                                </div>
                            </div>                                               
                        </div>  
                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color title-steps font-weight-tips">
                                    2. Layout your design
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={layoutsteps} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                        <p className="step-size">
                                           You should already have an idea of why you’re designing a shirt, and may have already came up with a few concepts.
                                        </p>
                                        <p className="step-size">
                                           The design could go a million different ways, which is why you need to take the time to visualize the design from your mind to a paper.
                                        </p>
                                        <p className="step-size">
                                            To make it easier, create a detailed list of the components that you want to include. Take time to sketch out an initial draft and make several variations to come up with the best one. You also have to consider the details of the design that works well together to unify the concept.
                                        </p>
                                        <p className="step-size">
                                            Style and Imagery:-
                                        </p>
                                        <p className="step-size">
                                            Design like a style and imagery depend on what your brand wants to convey and what sort of audience the shirts will be presented to. For instance, a brand catering to teens will likely use animated characters and components that spell fun and stylish.
                                        </p>
                                        <p className="step-size">
                                            Corporate Logos:-
                                        </p>
                                        <p className="step-size">
                                            Designing for corporate depends on your business logos and sometime you may add a text to convey a message for your team or the company
                                        </p>
                                        <p className="step-size">
                                            Events:-
                                        </p>
                                        <p className="step-size">
                                            Designing for any events like (Birthdays, Anniversaries, Baby shower, Graduations) you would like to add memory photos along with a few words “Happy Birthday”
                                        </p>
                                        <p className="step-size">
                                            Color Scheme
                                        </p>
                                        <p className="step-size">
                                            Personality is better expressed using a color scheme. Every graphic designer knows how indispensable shades, tints, and hues are in designing, although you have to more careful when applying color palettes on a shirt. 
                                        </p>
                                    </div>                                   
                                </div>
                            </div>                                               
                        </div> 
                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color title-steps font-weight-tips">
                                 3. T-Shirt Design Placement
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={wrongWay} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                       <p className="step-size">Sizing in T-shirt designing does matter here a lot. Keep these tips in mind while designing your own Tees. </p>
                                    </div>                                   
                                </div>
                            </div> 
                            <div className="col-md-12 mt-2">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={rightWay} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                       <p className="step-size">Sizing in T-shirt designing does matter here lot. Keep these ta ips in mind while designing your own Tees. </p>
                                    </div>                                   
                                </div>
                            </div>                                               
                        </div>

                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color title-steps font-weight-tips">
                                    4. Get the composition right
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={compositionRight} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                       <p className="step-size">Composition is one of the fundamental lessons in the Art classes, and it should stay relevant to any graphic designing. </p>
                                       <p className="step-size">Every concept that has multiple elements need to be arranged relative to space and each other.</p>
                                       <p className="step-size">As per many designers the suggestions are to  stay within the well-composed idea depending on an individual opinion, but sticking to some basic composition guidelines can enhance the design.</p>
                                    </div>                                   
                                </div>
                            </div>                                                                           
                        </div>

                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color title-steps font-weight-tips">
                                    5. Pay attention to image quality
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={payImage} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                       <p className="step-size">The image file might be good enough to view, but a low-resolution image will not look good on print. When creating a t-shirt design, stay away from low-res and ensure that the pixel information is adequate for a quality print. </p>
                                       <p className="step-size">These file types include Max file size: 5mb, accepted: jpg, gif,and png. For photographs, it’s better to scan at high resolution rather than taking a picture of it. Photos on photo tend to be blurry and sometimes unnecessarily cropped</p>
                                    </div>                                   
                                </div>
                            </div>                                                                           
                        </div>  

                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color title-steps font-weight-tips">
                                6. Complex or simple?
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={complex} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                       <p className="step-size">In graphics designing adding too many intricate details on a t-shirt design can ruin its overall aesthetic value. The human attention span lasts only for a few seconds, and you must make the best impression during those seconds. Shirt design is a moving graphic ad,<strong> so keeping it simple is better.</strong></p>
                                       <p className="step-size">When trying for originality and creativity, it’s easy to get carried away and put in as many elements as possible, but stacking images, one on top of the other, creates weird angles and messes up the composition. You don’t want the concept to be messy and headache-inducing to the viewer.</p>
                                       <p className="step-size">It would be remarkable to have a well-executed masterpiece printed on a shirt, but <strong> complex doesn’t always mean it’s more attractive.</strong></p>
                                       <p className="step-size">Remember, it shouldn’t be so hard to figure out what the shirt wants to convey. Optimize the design, so it looks clean yet impactful. It might sound hard to achieve but if you get the concept right, it should be easy to finalize the design that would look perfect when printed on a shirt.</p>
                                       <p className="step-size"><strong>HAPPY CREATING AND PRINTING</strong></p>
                                    </div>                                   
                                </div>
                            </div>                                                                           
                        </div>    
                        <div className="mt-2">
                            <h2 className="elementor-heading-title elementor-size-default mb-1 text-center mb-1">
                                WHY DESIGN CUSTOMIZED MUGS
                            </h2>
                        </div>   
                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color title-steps font-weight-tips">
                                    7. Why Give Coffee Mugs?
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={Capture} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                       <h4 className="step-size">
                                           Advertising
                                        </h4>
                                       <p className="step-size">
                                           Coffee mugs make a great canvas for your business logo or to prominently display a message associated with your business. Because they’re useful, they’re less likely to be discarded and may even see daily use. 
                                        </p>
                                       <p className="step-size">
                                           Each time someone takes a drink from a mug decorated with your business’s logo or tagline, you’ll be getting more exposure for your enterprise. 
                                        </p>
                                       <h4 className="step-size">
                                            Gift-Giving
                                        </h4>
                                       <p className="step-size">
                                           Specially designed mugs make the perfect heartfelt — and useful — gift for that special person in your life.
                                        </p>
                                        <p className="step-size">
                                            Adorned with inspirational sayings, custom artwork, and even personalised with the recipient’s name, a bespoke mug will convey the perfect sentiment for any occasion.
                                        </p>
                                        <h4 className="step-size">
                                            Home Décor
                                        </h4>
                                        <p className="step-size">
                                            A set of custom-printed mugs can be just the right addition to your kitchen or office. They can range from the simple, like monogrammed mugs or a set of inspirational sayings, to the sublime, like full-colour artwork or photographs.
                                        </p>
                                        <p className="step-size">
                                            No matter how you design them, custom mugs can inject your home with a touch of personality.
                                        </p>
                                        <h4 className="step-size">
                                            Home-Based Business
                                        </h4>
                                        <p className="step-size">
                                            Did you know that custom-printed mugs make an excellent idea for a work-from-home scheme?
                                        </p>
                                        <p className="step-size">
                                            Capitalising on the popularity of mugs is a great way to generate an income-producing business you can operate locally or online.
                                        </p>
                                        <p className="step-size">
                                            Simply create clever, one-of-a-kind designs or messages and have them carefully printed on high-quality mugs for an easy — and profitable — business idea.
                                        </p>
                                    </div>                                   
                                </div>
                            </div>                                               
                        </div>    
                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color title-steps font-weight-tips mb-1">
                                    8. TIPS TO MAKE YOUR OWN COFFEE MUG
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={mugTips} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                        <h1 className="step-size">
                                            1. Plan It Out
                                        </h1>
                                        <p className="step-size">
                                            Before undertaking any coffee mug design project, make sure you’ve planned out the design from start to finish. 
                                        </p>
                                        <p className="step-size">
                                            Things to consider include: 
                                        </p>
                                        <p className="step-size">
                                                • Does the design fit on the mug space?<br />
                                                • Will the design cover the entire mug or just one side?<br />
                                                • Will there be anything inside the mug?<br />
                                                • How many colours will the design use?<br />
                                                • Will the design be permanent, washable, or microwaveable?
                                        </p>
                                        <h1 className="step-size">
                                            2. Choose Your Base Mug for Durability
                                        </h1>
                                        <p className="step-size">
                                            You want to make sure your unique mug will be easy to take care of and stand up to years of use. That’s why you should look for mug blanks that are hand washable and dishwasher-safe for best results.
                                        </p>
                                        <h1 className="step-size">
                                            3. Use Color-Wisely
                                        </h1>
                                        <p className="step-size">
                                            Color can add real impact and value to your mug design, but sometimes too many colors can overpower an image and end up looking messy
                                        </p>
                                        <p className="step-size">
                                            Determine the right level of colour for your mug before undertaking the final product. A sketch is a great way to see if your design colors are just right — or is it too much.
                                        </p>
                                        <p className="step-size">
                                            If you’re having your mug professionally printed, using fewer colors can save you money.
                                        </p>
                                    </div>                                   
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={mugTips1} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                        <h1 className="step-size">
                                            4. Choose Your Color Mug
                                        </h1>
                                        <p className="step-size">
                                            Make every day’s tea and coffee a treat for yourself, add a little extra creativity. A larger-volume mug can make your and your’s love ones day a very special day! A big mug also fit more comfortably into the hands. 
                                        </p>
                                        <h1 className="step-size">
                                            5. Be Inspirational To Others
                                        </h1>
                                        <p className="step-size">
                                            People love to be inspired! Create <b>#Makeitwithstylecabbie</b> and Share your unique designing capabilities with us and others via <b>#Sharewithstylecabbie</b>. We would love to know about you and your creativity stories behind it. It’s time to show and tell your talent to others. 
                                        </p>
                                        <p className="step-size">
                                            You can choose a quote from a favourite public figure, author, or actor or even one of the memes circulating online to add a spark of inspiration to your custom mug.
                                        </p>
                                        <h1 className="step-size">
                                            6. Be Creative
                                        </h1>
                                        <p className="step-size">
                                            You’ll want to see your design in action before committing to printing or hand-making a mug. Sometimes, what seems good in your head doesn’t translate as well to a mug.
                                        </p>
                                        <p className="step-size">
                                            Take the time to sketch a drawing of your design on paper or cut a hand-drawn paper design out and test it on a mug to get a good idea for how the final product will look.
                                        </p>
                                    </div>                                   
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={mugTips2} alt="tipsImage"/>
                                        <img src={mugTips3} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                        <h1 className="step-size">
                                            7. Make It Memorable
                                        </h1>
                                        <p className="step-size">
                                            The more memorable your mug design, the more likely the recipient will give it pride of place in their home or office. Use designs that are unique or eye-catching to make your mug stand out from the rest. 
                                        </p>
                                        <h1 className="step-size">
                                            8. Share With Others
                                        </h1>
                                        <p className="step-size">
                                            Sharing your inner creativities outside your own drawing pages and let the world appreciate it. Take this leverage to create something that it very unique and different than what is available in the marketplace today and <b>#Sharewithstylecabbie</b>
                                        </p>
                                        <h1 className="step-size">
                                            9. Be Yourself
                                        </h1>
                                        <p className="step-size">
                                            One of the best ways to design your own coffee mug is to professionally print one at a custom printing shop online with StyleCabbie
                                        </p>
                                        <p className="step-size">
                                            StyleCabbie makes mug designing easy. You can upload your own design and add text through the online portal.
                                        </p>
                                        <p className="step-size">
                                            Having a professional printer transfer your custom artwork or photo onto a mug is one of the best ways to produce sharp, clear colours and lines coupled with unbeatable durability.
                                        </p>
                                        <p className="step-size">
                                            Mugs usually ship within 24 hours and are packed in durable boxes that are perfect for gift-wrapping and giving. 
                                        </p>
                                        <p className="step-size">
                                            <b>All you have to do is draw out your design, take an image, transfer it to the mugs online. Place it to the three sections {'>>'} Left Side, Center ,and Right side of the Mug. You can add three different designs or mix-match with image and texts.</b>
                                        </p>
                                    </div>                                   
                                </div>
                            </div>    
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={mugTips4} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                        <h1 className="step-size mb-1">
                                            Why Make Your Own Coffee Mug Design?
                                        </h1>
                                        <p className="step-size">
                                            here are plenty of coffee mug designs out there, as a quick click around the internet or a browse in your local big-box store will attest. So, why should you bother designing your own? 
                                        </p>
                                        <p className="step-size">
                                            A custom-designed mug adds a touch of class, character, and charm that plain, store-bought mugs <b>just can’t match</b>. When you make your own coffee mug design, you create an end product that is uniquely yours.
                                        </p>
                                        <p className="step-size">
                                            These file types include Max file size: 5mb, accepted: jpg, gif ,and png. 
                                        </p>
                                        <p className="step-size">
                                            One of the best ways to design your own coffee mug is to professionally print one (or more) at a custom printing online shop  with StyleCabbie. 
                                        </p>
                                        <p className="step-size">
                                            Contact us today to learn more!
                                        </p>
                                        <p className="step-size">
                                            Remember to #tag your creativity designs  <b>#Makeitwithstylecabbie</b>  and <b>#Sharewithstylecabbie</b>.  
                                        </p>
                                        <div className="social-icons">
                                            <div className="links1">Follow us on</div>  
                                            <a href="https://www.facebook.com/stylecabbie" className="social-icon" target="_blank" rel="noopener noreferrer"><i className="icon-facebook"></i></a>
                                            <a href="https://www.instagram.com/stylecabbie/" className="social-icon" target="_blank" rel="noopener noreferrer"><i className="icon-instagram"></i></a>
                                            {/* <a href="/" className="social-icon" target="_blank"><i className="icon-linkedin"></i></a> */}
                                        </div>
                                    </div>                                   
                                </div>
                            </div>                                                
                        </div>   
                        <div className="mt-2">
                            <h2 className="elementor-heading-title elementor-size-default mb-1 text-center">
                                Design Your Own Custom Phone Case Online
                            </h2>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={mobileCostomize} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                        <h1 className="step-size mb-1">
                                            How To Make A Custom Phone Case
                                        </h1>
                                        <p className="step-size">
                                            1. <b>Phone Brand</b>: Create a custom phone case by selecting the <b>Brand</b>. 
                                        </p>
                                        <p className="step-size">
                                            2. <b>Phone Model</b> : Choose the right <b>Model</b> within selected <b>Brand</b> 
                                        </p>
                                        <p className="step-size">
                                            3. <b>Choose Image</b> : Upload an image. The file types include Max file size: 5mb, accepted: jpg, gif ,and png.  
                                        </p>
                                        <p className="step-size">
                                            4. <b>Add Text/Image</b> :  Add multiple text and/ or add Image or both. The file types include Max file size: 5mb, accepted: jpg, gif ,and png.
                                        </p>
                                        <p className="step-size">
                                            5. <b>Add To Cart</b>: Select <b>Add to Cart</b> for your custom made phone case.
                                        </p>
                                    </div>                                   
                                </div>
                            </div>      
                        </div>                            
                    </div>
                </main>
                <Footer />
            </React.Fragment>
        )
    }
}
export default  TipsOnDesigningTees 
